import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Intent } from 'onevoice';
import { Observable } from 'rxjs';
import { Parameter } from './parameter.service';

export interface IntentForwarder {
    id?: number;
    origin?: Intent;
    destination?: Intent;
    trigger?: Parameter;
    answer?: string;
}

@Injectable({
    providedIn: 'root'
})
export class IntentForwarderService {
    url: string = `${environment.coreService}/api/intents/forwarders`;

    constructor(private _httpClient: HttpClient) { }

    list(intent?: number): Observable<IntentForwarder[]> {
        let params: HttpParams = new HttpParams();
        if (intent) {
            params = params.set('intent', `${intent}`);
        }
        return this._httpClient.get<IntentForwarder[]>(this.url, {
            params: params
        });
    }

    get(id: number): Observable<IntentForwarder> {
        return this._httpClient.get<IntentForwarder>(`${this.url}/${id}`);
    }

    create(data: IntentForwarder): Observable<IntentForwarder> {
        return this._httpClient.post<IntentForwarder>(this.url, data);
    }

    update(data: IntentForwarder): Observable<IntentForwarder> {
        return this._httpClient.post<IntentForwarder>(
            `${this.url}/${data.id}`,
            data,
            {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json'
                })
            }
        );
    }

    delete(data: IntentForwarder): Observable<any> {
        return this._httpClient.delete(`${this.url}/${data.id}`);
    }
}
